<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>
<div class="card-body-tab">
    <div class="col-12 px-2">
        <div class="cards-body">
            <div class="tableSpacing">
                <div class="box-body table-responsive-sm table-responsive-md table-responsive-lg overflow-x-auto">
                    <table id="blocktime_report_table" class="table card-layout table-striped table">
                        <thead>
                            <tr id="blocktimeRecord_headingId">
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <div
                                            class="header-color cursorPointer reportfield-width background-color-whiteSmoke box-shadow-whiteSmoke position-sticky left-minus_0_5">
                                            Action
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width background-color-whiteSmoke position-sticky left-9_5"
                                            (click)="sortBy='srCreatedOnDate'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.srCreatedOnDate = !blockTimeReportSorting.srCreatedOnDate;">
                                            Date
                                            <i *ngIf="blockTimeReportSorting.srCreatedOnDate"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.srCreatedOnDate"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width background-color-whiteSmoke position-sticky left-19_5"
                                            (click)="sortBy='tripID'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.tripID = !blockTimeReportSorting.tripID;">
                                            Trip #
                                            <i *ngIf="blockTimeReportSorting.tripID"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.tripID"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width background-color-whiteSmoke position-sticky left-29_5"
                                            (click)="sortBy='customerName'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.customerName = !blockTimeReportSorting.customerName;">
                                            Customer
                                            <i *ngIf="blockTimeReportSorting.customerName"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.customerName"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width" (click)="sortBy='serviceType'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.serviceType = !blockTimeReportSorting.serviceType;">
                                            SR Type
                                            <i *ngIf="blockTimeReportSorting.serviceType"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.serviceType"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="sortBy='additionalOrgans'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.additionalOrgans = !blockTimeReportSorting.additionalOrgans;">
                                            Organ Type
                                            <i *ngIf="blockTimeReportSorting.additionalOrgans"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.additionalOrgans"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="sortBy='groundVendor'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.groundVendor = !blockTimeReportSorting.groundVendor;">
                                            Ground Vendor
                                            <i *ngIf="blockTimeReportSorting.groundVendor"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.groundVendor"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width" (click)="sortBy='unosid'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.unosid = !blockTimeReportSorting.unosid;">
                                            Unos ID
                                            <i *ngIf="blockTimeReportSorting.unosid"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.unosid"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width" (click)="sortBy='airVendor'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.airVendor = !blockTimeReportSorting.airVendor;">
                                            Air Vendor
                                            <i *ngIf="blockTimeReportSorting.airVendor"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.airVendor"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width"
                                             (click)="sortBy='outboundReposition'; sortOrder = !sortOrder; blockTimeReportSorting.outboundReposition = !blockTimeReportSorting.outboundReposition;"
                                        >
                                            OB Repo
                                            <i *ngIf="blockTimeReportSorting.outboundReposition" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.outboundReposition" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width"
                                             (click)="sortBy='obEstimatedBlockHours'; sortOrder = !sortOrder; blockTimeReportSorting.obEstimatedBlockHours = !blockTimeReportSorting.obEstimatedBlockHours;"
                                        >
                                            OB Repo Hours
                                            <i *ngIf="blockTimeReportSorting.obEstimatedBlockHours" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.obEstimatedBlockHours" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width"
                                             (click)="sortBy='routing'; sortOrder = !sortOrder; blockTimeReportSorting.routing = !blockTimeReportSorting.routing;"
                                        >
                                            Routing
                                            <i *ngIf="blockTimeReportSorting.routing" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.routing" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width"
                                             (click)="sortBy='liveFlightHours'; sortOrder = !sortOrder; blockTimeReportSorting.routing = !blockTimeReportSorting.liveFlightHours;"
                                        >
                                            Live Flight Hours
                                            <i *ngIf="blockTimeReportSorting.liveFlightHours" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.liveFlightHours" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width"
                                            (click)="sortBy='inboundReposition'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.inboundReposition = !blockTimeReportSorting.inboundReposition;">
                                            IB Repo
                                            <i *ngIf="blockTimeReportSorting.inboundReposition"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.inboundReposition"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width"
                                            (click)="sortBy='ibEstimatedBlockHours'; sortOrder = !sortOrder; blockTimeReportSorting.ibEstimatedBlockHours = !blockTimeReportSorting.ibEstimatedBlockHours;"
                                        >
                                            IB Repo Hours
                                            <i *ngIf="blockTimeReportSorting.ibEstimatedBlockHours" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.ibEstimatedBlockHours" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="sortBy='tailNumber'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.tailNumber = !blockTimeReportSorting.tailNumber;">
                                            Tail Number
                                            <i *ngIf="blockTimeReportSorting.tailNumber"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.tailNumber"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="sortBy='aircraftType'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.aircraftType = !blockTimeReportSorting.aircraftType;">
                                            Aircraft Types
                                            <i *ngIf="blockTimeReportSorting.aircraftType"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.aircraftType"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="sortBy='estimatedBlockHours'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.estimatedBlockHours = !blockTimeReportSorting.estimatedBlockHours;">
                                            Est. Block Hours
                                            <i *ngIf="blockTimeReportSorting.estimatedBlockHours"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.estimatedBlockHours"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width reportfield-width-17"
                                            (click)="sortBy='blockHours'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.actualBlockTime = !blockTimeReportSorting.actualBlockTime;">
                                            Actual Block Time
                                            <i *ngIf="blockTimeReportSorting.actualBlockTime"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.actualBlockTime"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width reportfield-width-17"
                                             (click)="sortBy='cancellationHours'; sortOrder = !sortOrder; blockTimeReportSorting.cancellationHours = !blockTimeReportSorting.cancellationHours;"
                                        >
                                          Cancellation Hours
                                          <i *ngIf="blockTimeReportSorting.cancellationHours" class="fa fa-chevron-up margin-left-7"></i>
                                          <i *ngIf="!blockTimeReportSorting.cancellationHours" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="sortBy='aircraftSize'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.aircraftSize = !blockTimeReportSorting.aircraftSize;">
                                            Aircraft Size
                                            <i *ngIf="blockTimeReportSorting.aircraftSize"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.aircraftSize"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width" (click)="sortBy='cost'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.cost = !blockTimeReportSorting.cost;">
                                            Cost
                                            <i *ngIf="blockTimeReportSorting.cost"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.cost"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width" (click)="sortBy='profit'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.profit = !blockTimeReportSorting.profit;">
                                            Profit
                                            <i *ngIf="blockTimeReportSorting.profit"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.profit"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width" (click)="sortBy='rate'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.rate = !blockTimeReportSorting.rate;">
                                            Rate
                                            <i *ngIf="blockTimeReportSorting.rate"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.rate"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="sortBy='flightMargin'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.flightMargin = !blockTimeReportSorting.flightMargin;">
                                            Flight Margin
                                            <i *ngIf="blockTimeReportSorting.flightMargin"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.flightMargin"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width" (click)="sortBy='invoiceID'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.invoiceID = !blockTimeReportSorting.invoiceID;">
                                            Invoice #
                                            <i *ngIf="blockTimeReportSorting.invoiceID"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.invoiceID"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width d-flex justify-content-center"
                                            (click)="sortBy='ar'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.ar = !blockTimeReportSorting.ar;">
                                            <span>A/R</span>
                                            <i *ngIf="blockTimeReportSorting.ar"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.ar"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width d-flex justify-content-center"
                                            (click)="sortBy='ap'; sortOrder = !sortOrder;
                                            blockTimeReportSorting.ap = !blockTimeReportSorting.ap;">
                                            <span>A/P</span>
                                            <i *ngIf="blockTimeReportSorting.ap"
                                                class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.ap"
                                                class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width">
                                            <span>Note</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let record of blockTimeReportData | orderBy: sortBy:sortOrder | filter: searchText | paginate: {itemsPerPage: selectedPage, currentPage: currentPageNumber }; let record_index = index">
                                <td>
                                    <div class="row_container" id="blocktimeRecord_main_row_id">
                                        <div [ngClass]="(record_index%2==0) ? 'background-color-white box-shadow-white' : 'background-color-whiteSmoke box-shadow-whiteSmoke'"
                                            class="title_container reportfield-width position-sticky left-minus_0_5">
                                            <div class="row_title">Action</div>
                                            <div class="row_detail">
                                                <button [disabled]="isInternalReadOnly" id="editBlockTimeReportButton"
                                                    [ngClass]="isInternalReadOnly ? 'notAllowedPointer' : ''"
                                                    class="mr-2 flat-butt flat-info-butt flat-info-grad-butt add-note-button"
                                                    title="Edit blocktime record" data-toggle="modal" data-target="#addBlockTimeReportRecord"
                                                    (click)="openEditBlockTimeReport(record)">
                                                    <i class="fa fa-pencil"></i>
                                                </button>
                                                <button id="deleteBlockTimeReportButton"
                                                    class="flat-butt flat-info-butt flat-info-grad-butt add-note-button"
                                                    title="Delete blocktime record"
                                                    (click)="deleteBlockTimeRecord(record.blockTimeReportID)"
                                                    [ngClass]="isInternalReadOnly || !record.blockTimeReportID ? 'notAllowedPointer' : ''"
                                                    [disabled]="!record.blockTimeReportID || isInternalReadOnly">
                                                    <i class="fa fa-minus-circle"></i>
                                                </button>
                                                <button id="splitBlockTimeReportButton"
                                                    *ngIf="!record.isRecordSplitted && record.parentBlockTimeReportID == null"
                                                    class="flat-butt flat-info-butt flat-info-grad-butt add-note-button"
                                                    title="Split the record"
                                                    (click)="openSplitBlockTimeRecordPopup(record)"
                                                    [ngClass]="isInternalReadOnly ? 'notAllowedPointer' : ''"
                                                    [disabled]="isInternalReadOnly">
                                                    <i class="fa fa-scissors"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div [ngClass]="(record_index%2==0) ? 'background-color-white' : 'background-color-whiteSmoke'"
                                            class="title_container reportfield-width position-sticky left-9_5">
                                            <div class="row_title">Date</div>
                                            <div class="row_detail">
                                                {{record?.srCreatedOnDate | date : timeZone}}
                                            </div>
                                        </div>
                                        <div [ngClass]="(record_index%2==0)? 'background-color-white' : 'background-color-whiteSmoke'"
                                            class="title_container reportfield-width position-sticky left-19_5">
                                            <div class="row_title">Trip #</div>
                                            <div class="row_detail cursorPointer">
                                                <a
                                                    href="{{itineraryPageRedirectUrl}}/{{record.serviceRequestID}}/Report">
                                                    {{record.tripID}}
                                                </a>
                                            </div>
                                        </div>
                                        <div [ngClass]="(record_index%2==0) ? 'background-color-white' : 'background-color-whiteSmoke'"
                                            class="title_container reportfield-width position-sticky left-29_5">
                                            <div class="row_title">Customer</div>
                                            <div class="row_detail">
                                                {{record?.customer?.customerName}}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">SR Type</div>
                                            <div class="row_detail">
                                                {{ record.serviceType }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Organ Type</div>
                                            <div class="row_detail" style="max-height:5rem;overflow-y:auto">
                                                {{ record.additionalOrgans }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Ground Vendor</div>
                                            <div class="row_detail">
                                              {{ record.groundVendor }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Unos ID</div>
                                            <div class="row_detail">
                                                {{record.unosid}}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Air Vendor</div>
                                            <div class="row_detail">
                                                {{record.airVendor }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">OB Repo</div>
                                            <div class="row_detail">
                                                {{ record.outboundReposition }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">OB Repo Hours</div>
                                            <div class="row_detail">
                                                {{ record.obEstimatedBlockHours | number: '1.2-2' }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Routing</div>
                                            <div class="row_detail">
                                                {{record.routing}}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Live Flight Hours</div>
                                            <div class="row_detail">
                                                {{ record.liveFlightHours }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">IB Repo</div>
                                            <div class="row_detail">
                                                {{record.inboundReposition}}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">IB Repo Hours</div>
                                            <div class="row_detail">
                                                {{ record.ibEstimatedBlockHours | number: '1.2-2' }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Tail Number</div>
                                            <div class="row_detail">
                                                <a href="https://flightaware.com/live/flight/{{record.tailNumber}}" target="blank">
                                                  {{record.tailNumber}}
                                                </a>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Aircraft Types</div>
                                            <div class="row_detail">
                                                {{record.aircraftType}}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Est. Block Hours</div>
                                            <div class="row_detail">
                                                {{record.estimatedBlockHours}}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-17">
                                            <div class="row_title">Actual Block Time</div>
                                            <div class="row_detail">
                                                {{record.actualBlockTime}}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-17">
                                          <div class="row_title">Cancellation Hours</div>
                                          <div class="row_detail">
                                            {{ record.cancellationHours | number: '1.2-2'}}
                                          </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Aircraft Size</div>
                                            <div class="row_detail">
                                                {{record.aircraftSize}}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Cost</div>
                                            <div class="row_detail">
                                              <ng-container *ngIf="record.cost">
                                                {{ record.cost }} $
                                              </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Profit</div>
                                            <div class="row_detail">
                                              <ng-container *ngIf="record.profit">
                                                {{ record.profit }} $
                                              </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Rate</div>
                                            <div class="row_detail">
                                              <ng-container *ngIf="record.rate">
                                                {{ record.rate }} %
                                              </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Flight Margin</div>
                                            <div class="row_detail">
                                              <ng-container *ngIf="record.flightMargin">
                                                {{ record.flightMargin }} %
                                              </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Invoice #</div>
                                            <div class="row_detail">
                                                {{record.invoiceID}}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">A/R</div>
                                            <div class="row_detail d-flex justify-content-center">
                                                <input type="checkbox" class="block_time_report_checkbox"
                                                    [(ngModel)]="record.ar" (change)="updateArOrAp(record, 'A/R')"
                                                    [disabled]="isInternalReadOnly">
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">A/P</div>
                                            <div class="row_detail d-flex justify-content-center">
                                                <input type="checkbox" class="block_time_report_checkbox"
                                                    [(ngModel)]="record.ap" (change)="updateArOrAp(record, 'A/P')"
                                                    [disabled]="isInternalReadOnly">
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Note</div>
                                            <div class="row_detail">
                                                <input type="textarea" class="form-control cursorPointer"
                                                    id="note-{{record_index}}" data-toggle="popover"
                                                    [(ngModel)]="record.note" (click)="togglePopOver()"
                                                    data-placement="auto left" [attr.data-content]="record.note"
                                                    readonly>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="blockTimeReportData.length==0" style="color: #a82b41" class="mt-2">
                    <b>No Records Found</b>
                </div>
                <div class="col-md-12 p-3" *ngIf="blockTimeReportData.length > 0">
                    <div class="col-md-6 p-0">
                        {{ pagination }}
                    </div>
                    <div class="col-md-6 pagination text-end mt-1">
                        <pagination-controls [maxSize]="6" [previousLabel]="''" [nextLabel]="''"
                            [responsive]="responsive" (pageChange)="currentPageNumber = $event;onPageChange()">
                        </pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-block-time-report-grid [data]="totalOfBlockTimeReportValues"></app-block-time-report-grid>

<!-- todo: refactoring. move it to the separate component -->
<div class="modal" data-backdrop="static" data-keyboard="false" id="addBlockTimeReportRecord" *ngIf="isOpenAddEditBlockTimeRecordPopUp">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close" (click)="closeBlockTimeReportModel()">
          <i class=" fa fa-close"></i>
        </button>
        <h4 class="modal-title">{{ isEditBlockTimeRecord ? 'Edit' : 'Add New' }} Record</h4>
      </div>
      <form name="addEditBlockTimeReportForm" #blockTimeReportForm="ngForm">
        <div class="modal-body">
          <div class="member-card">
            <div class="dialog-row">
              <div class="dialog-cell">
                <div class="form-group">
                  <label>
                    <span>Trip #</span><span class="text-danger"> * </span>
                    <span *ngIf="blockTimeReportForm.submitted && tripID.invalid">
                      <span *ngIf="tripID.hasError('required')" class="text-danger">required</span>
                    </span>
                  </label>
                  <ngx-select-dropdown #ngxSelectDropDownCustomer
                                       id="tripID"
                                       name="tripID"
                                       #tripID="ngModel"
                                       tabindex="0"
                                       [multiple]="false"
                                       [ngClass]="blockTimeReportForm.submitted && customer.invalid ? 'is-invalid-dropdown' : ''"
                                       [config]="tripDropdownConfig"
                                       [options]="trips"
                                       [(ngModel)]="blockTimeReportRecord.tripID"
                                       (change)="onTripChange($event.value)"
                                       required
                                       (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownCustomer)"
                  ></ngx-select-dropdown>
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>
                    <span>Customer </span><span class="text-danger">*</span>
                    <span *ngIf="blockTimeReportForm.submitted && customer.invalid">
                      <span *ngIf="customer.errors.required" class="text-danger">required</span>
                    </span>
                  </label>
                  <ngx-select-dropdown #ngxSelectDropDownCustomer
                                       id="customer"
                                       name="customer"
                                       #customer="ngModel"
                                       tabindex="0"
                                       [multiple]="false"
                                       [ngClass]="blockTimeReportForm.submitted && customer.invalid ? 'is-invalid-dropdown' : ''"
                                       [config]="customerListDropdownSetting"
                                       [options]="customerList"
                                       [(ngModel)]="blockTimeReportRecord.customer"
                                       required
                                       (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownCustomer)"
                  ></ngx-select-dropdown>
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>
                    <span>Date </span>
                    <span class="text-danger">*</span>
                    <span *ngIf="blockTimeReportForm.submitted && srCreatedOnDate.invalid">
                      <span *ngIf="srCreatedOnDate.errors.required" class="text-danger">required</span>
                    </span>
                  </label>
                  <input type="date"
                         [ngModel]="blockTimeReportRecord.srCreatedOnDate | date:'yyyy-MM-dd'"
                         id="srCreatedOnDate"
                         placeholder="srCreatedOnDate"
                         name="srCreatedOnDate"
                         #srCreatedOnDate="ngModel"
                         [max]="maxDate"
                         class="form-control"
                         [ngClass]="blockTimeReportForm.submitted && srCreatedOnDate.invalid ? 'is-invalid' : ''"
                         required
                         [disabled]="isEditBlockTimeRecord"
                         readonly
                         onfocus="this.showPicker()">
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>
                    <span>SR Type </span>
                    <span *ngIf="blockTimeReportForm.touched && serviceType.invalid">
                      <span *ngIf="serviceType.errors.pattern" class="text-danger">Alphabets only</span>
                    </span>
                  </label>
                  <input type="text"
                         readonly
                         id="serviceType"
                         name="serviceType"
                         #serviceType="ngModel"
                         tabindex="1"
                         class="form-control"
                         [(ngModel)]="blockTimeReportRecord.serviceType"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>
                    <span>Organ Type</span>
                    <span *ngIf="blockTimeReportForm.touched && additionalOrgans.invalid">
                      <span *ngIf="additionalOrgans.errors.pattern">Alphabets only</span>
                    </span>
                  </label>
                  <input id="additionalOrgans"
                         name="additionalOrgans"
                         #additionalOrgans="ngModel"
                         placeholder="Select Trip #"
                         [ngClass]="blockTimeReportForm.touched && additionalOrgans.invalid ? 'is-invalid' : ''"
                         [(ngModel)]="blockTimeReportRecord.additionalOrgans"
                         readonly
                         class="form-control"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Unos ID</label>
                  <input type="text"
                         [(ngModel)]="blockTimeReportRecord.unosid"
                         id="unosid"
                         placeholder="Unos ID"
                         name="unosid"
                         class="form-control"
                         #unosid="ngModel"
                         readonly
                         [disabled]="isEditBlockTimeRecord"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Ground Vendor</label>
                  <input id="groundVendor"
                         name="groundVendor"
                         #groundVendor="ngModel"
                         placeholder="Select Trip #"
                         [(ngModel)]="blockTimeReportRecord.groundVendor"
                         readonly
                         class="form-control"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Air Vendor</label>
                  <span class="text-danger"> * </span>
                  <ngx-select-dropdown id="airVendor"
                                       name="airVendor"
                                       #airVendor="ngModel"
                                       tabindex="0"
                                       required
                                       [multiple]="false"
                                       [ngClass]="blockTimeReportForm.submitted && airVendor.invalid ? 'is-invalid-dropdown' : ''"
                                       [config]="airVendorConfig"
                                       [options]="airVendorList"
                                       [(ngModel)]="airVendorValue"
                                       [disabled]="isEditBlockTimeRecord"
                                       (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownCustomer)"
                                       (change)="onSelectAirVendor($event.value)"
                  ></ngx-select-dropdown>
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group position-relative">
                  <label>
                    <span>Tail Number </span>
                    <span class="text-danger"> *</span>
                    <span *ngIf="blockTimeReportForm.submitted && tailNumber.invalid">
                      <span *ngIf="tailNumber.errors.required" class="text-danger">required</span>
                    </span>
                  </label>
                  <span class="position-absolute top-left-position">N</span>
                  <ngx-select-dropdown #ngxSelectDropDownCustomer
                                       id="tailNumber"
                                       name="tailNumber"
                                       #tailNumber="ngModel"
                                       tabindex="0"
                                       [multiple]="false"
                                       [ngClass]="blockTimeReportForm.submitted && customer.invalid ? 'is-invalid-dropdown' : ''"
                                       [config]="tailNumberDropdownConfig"
                                       [options]="aircrafts"
                                       [(ngModel)]="tailNumberValue"
                                       [disabled]="isEditBlockTimeRecord"
                                       (change)="onTailNumberChange($event.value)"
                                       required
                                       (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownCustomer)"
                  ></ngx-select-dropdown>
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Aircraft Types</label>
                  <input type="text"
                         id="aircraftType"
                         name="aircraftType"
                         #aircraftType="ngModel"
                         tabindex="5"
                         readonly
                         class="form-control"
                         [value]="blockTimeReportRecord.aircraftType?.name"
                         [(ngModel)]="blockTimeReportRecord.aircraftType"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Aircraft Size</label>
                  <input type="text"
                         id="aircraftSize"
                         name="aircraftSize"
                         #aircraftSize="ngModel"
                         tabindex="6"
                         readonly
                         class="form-control"
                         [value]="blockTimeReportRecord.aircraftSize?.name"
                         [(ngModel)]="blockTimeReportRecord.aircraftSize"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>OB Repo</label>
                  <ngx-select-dropdown #ngxSelectDropDownOBRepoType
                                       id="outboundRepo"
                                       name="outboundReposition"
                                       #outboundRepo="ngModel"
                                       tabindex="3"
                                       [multiple]="false"
                                       [config]="returnConfiguration('OBRepo')"
                                       [options]="airportCodes"
                                       [(ngModel)]="blockTimeReportRecord.outboundReposition"
                                       (change)="blockTimeReportRecord.outboundReposition = $event.value"
                                       (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownOBRepoType)">
                  </ngx-select-dropdown>
                  <button type="button" title="Clear IB Repo" class="clear-btn plus-icon mt-0" (click)="blockTimeReportRecord.outboundReposition = null">
                    <i class="fa fa-times-circle"></i>
                  </button>
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>OB Repo Hours</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.obEstimatedBlockHours"
                         id="obEstimatedBlockHours"
                         placeholder="OB Repo Hours"
                         name="obEstimatedBlockHours"
                         class="form-control"
                         min="0"
                         #obEstimatedBlockHours="ngModel"
                         [disabled]="blockTimeReportRecord.isCancelledNoCost"
                         (change)="calculateActualBlockTime()"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Routing</label>
                  <input type="text"
                         [(ngModel)]="blockTimeReportRecord.routing"
                         id="routing"
                         placeholder="Routing"
                         name="routing"
                         class="form-control"
                         #routing="ngModel"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Live Flight Hours</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.liveFlightHours"
                         id="liveFlightHours"
                         placeholder="Live Flight Hours"
                         name="liveFlightHours"
                         class="form-control"
                         min="0"
                         #liveFlightHours="ngModel"
                         [disabled]="blockTimeReportRecord.isCancelledNoCost"
                         (change)="calculateActualBlockTime()"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>IB Repo</label>
                  <ngx-select-dropdown #ngxSelectDropDownIBRepoType
                                       id="inboundReposition"
                                       name="inboundReposition"
                                       #inboundReposition="ngModel"
                                       tabindex="4"
                                       [multiple]="false"
                                       [config]="returnConfiguration('IBRepo')"
                                       [options]="airportCodes"
                                       [(ngModel)]="blockTimeReportRecord.inboundReposition"
                                       (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownIBRepoType)">
                  </ngx-select-dropdown>

                  <button type="button" title="Clear IB Repo" class="clear-btn plus-icon mt-0" (click)="blockTimeReportRecord.inboundReposition = null">
                    <i class="fa fa-times-circle"></i>
                  </button>
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>IB Repo Hours</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.ibEstimatedBlockHours"
                         id="ibEstimatedBlockHours"
                         placeholder="IB Repo Hours"
                         name="ibEstimatedBlockHours"
                         class="form-control"
                         min="0"
                         [disabled]="blockTimeReportRecord.isCancelledNoCost"
                         #ibEstimatedBlockHours="ngModel"
                         (change)="calculateActualBlockTime()"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Est. Block Hours</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.estimatedBlockHours"
                         id="estimatedBlockHours"
                         placeholder="Est. Block Hours"
                         name="estimatedBlockHours"
                         class="form-control"
                         [disabled]="blockTimeReportRecord.isCancelledNoCost"
                         #estimatedBlockHours="ngModel"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Actual Block Time</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.actualBlockTime"
                         id="actualBlockTime"
                         placeholder="Actual Block Time"
                         name="actualBlockTime"
                         class="form-control"
                         #actualBlockTime="ngModel"
                         readonly
                  >
                </div>
              </div>
              <div *ngIf="!(isEditBlockTimeRecord && blockTimeReportRecord.isCancelledNoCost)" class="dialog-cell">
                <div class="form-group">
                  <label>Cancellation Hours</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.cancellationHours"
                         id="cancellationHours"
                         placeholder="Cancellation Hours"
                         name="cancellationHours"
                         class="form-control"
                         min="0"
                         #cancellationHours="ngModel"
                         (change)="calculateActualBlockTime()"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Cost</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.cost"
                         id="cost"
                         (ngModelChange)="calculateRateAndFlightMargin()"
                         placeholder="Cost"
                         name="cost"
                         class="form-control"
                         #cost="ngModel"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Profit</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.profit"
                         id="profit"
                         (ngModelChange)="calculateRateAndFlightMargin()"
                         placeholder="Profit"
                         name="profit"
                         class="form-control"
                         #profit="ngModel"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group position-relative">
                  <label>Rate</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.rate"
                         id="rate"
                         placeholder="Rate"
                         name="rate"
                         class="form-control pr-5"
                         #rate="ngModel"
                         disabled
                  >
                  <span class="position-absolute top-right-position">%</span>
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group position-relative">
                  <label>Flight Margin</label>
                  <input type="number"
                         [(ngModel)]="blockTimeReportRecord.flightMargin"
                         id="flightMargin"
                         placeholder="Flight Margin"
                         name="flightMargin"
                         class="form-control pr-5"
                         #flightMargin="ngModel"
                         disabled
                  >
                  <span class="position-absolute top-right-position">%</span>
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>Invoice #</label>
                  <input type="text"
                         [(ngModel)]="blockTimeReportRecord.invoiceID"
                         id="invoiceID"
                         placeholder="Invoice #"
                         name="invoiceID"
                         class="form-control"
                         #invoiceID="ngModel"
                  >
                </div>
              </div>
              <div class="dialog-cell">
                <div class="form-group">
                  <label>
                    <span>Month and Year </span><span class="text-danger">*</span>
                    <span *ngIf="blockTimeReportForm.submitted && monthYear.invalid">
                      <span *ngIf="monthYear.errors.required" class="text-danger">required</span>
                    </span>
                  </label>
                  <ngx-select-dropdown id="monthYear"
                                       name="monthYear"
                                       #monthYear="ngModel"
                                       tabindex="0"
                                       required
                                       [multiple]="false"
                                       [config]="monthYearDropdownSetting"
                                       [options]="monthYearList"
                                       [(ngModel)]="blockTimeReportRecord.monthYear"
                                       [disabled]="!blockTimeReportRecord.srCreatedOnDate"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label class="mt-2">Note</label>
                  <div>
                    <textarea [(ngModel)]="blockTimeReportRecord.note"
                              id="note"
                              rows="2"
                              class="form-control"
                              placeholder="Note"
                              name="note"
                              #note="ngModel"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12 px-0">
                <div *ngIf="isEditBlockTimeRecord" class="col-lg-3 col-md-4 col-sm-4 col-xs-4">
                  <div class="form-group">
                    <label class="mt-2">Contracted</label>
                    <div>
                      <input type="checkbox"
                             class="block_time_report_checkbox"
                             [(ngModel)]="blockTimeReportRecord.isContracted"
                             id="isContracted"
                             placeholder="Contracted"
                             name="isContracted"
                             #isContracted="ngModel"
                             [disabled]="true"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-xs-4">
                  <div class="form-group">
                    <label class="mt-2">A/R</label>
                    <div>
                      <input type="checkbox"
                             class="block_time_report_checkbox"
                             [(ngModel)]="blockTimeReportRecord.ar"
                             id="ar"
                             placeholder="A/R"
                             name="ar"
                             #ar="ngModel"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-xs-4">
                  <div class="form-group">
                    <label class="mt-2">A/P</label>
                    <div>
                      <input type="checkbox"
                             class="block_time_report_checkbox"
                             [(ngModel)]="blockTimeReportRecord.ap"
                             id="ap"
                             placeholder="A/P"
                             name="ap" #ap="ngModel"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button #cancelBtnRef class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10" data-dismiss="modal" (click)="closeBlockTimeReportModel()">
            Cancel
          </button>
          <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn" (click)="addEditBlockTimeRecord(blockTimeReportForm)">
            {{ isEditBlockTimeRecord ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
